import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export default function Facilities() {
  const { t } = useLang();

  return (
    <section id="facilities" data-testid="facilities-section" className="relative bg-black py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-end mb-16 md:mb-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-7"
          >
            <div className="text-xs tracking-[0.3em] uppercase font-bold text-[#FFCC00] mb-6">
              / 01 — {t.facilities.overline}
            </div>
            <h2 data-testid="facilities-title" className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.92]">
              {t.facilities.title}
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="md:col-span-5 text-base md:text-lg text-white/70 font-body leading-relaxed"
          >
            {t.facilities.desc}
          </motion.p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-3 md:gap-4" data-testid="facilities-grid">
          {t.facilities.items.map((item, i) => {
            const spans = [
              "md:col-span-4 md:row-span-2 h-[360px] md:h-[560px]",
              "md:col-span-2 h-[280px]",
              "md:col-span-2 h-[280px]",
              "md:col-span-6 h-[360px]",
            ];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, delay: i * 0.1 }}
                data-testid={`facility-card-${i}`}
                className={`group relative overflow-hidden bg-[#0A0A0A] border border-white/10 hover:border-[#FFCC00]/40 transition-colors ${spans[i]}`}
              >
                {/* Subtle yellow corner accent on hover */}
                <div className="pointer-events-none absolute -top-20 -right-20 w-48 h-48 bg-[#FFCC00]/0 group-hover:bg-[#FFCC00]/[0.04] rounded-full blur-3xl transition-colors duration-700" />

                <div className="relative h-full p-6 md:p-10 flex flex-col items-center justify-center text-center">
                  <div className="flex items-center gap-2 mb-6">
                    <span className="inline-block w-2 h-2 bg-[#FFCC00] rotate-45" />
                    <span className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#FFCC00]">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-display text-4xl md:text-5xl lg:text-6xl text-white mb-4 leading-[0.95]">{item.title}</h3>
                  <p className="text-sm md:text-base text-white/65 max-w-md">{item.desc}</p>
                </div>

                <div className="absolute top-4 right-4 w-10 h-10 border border-white/15 flex items-center justify-center text-white/50 text-xs font-bold group-hover:border-[#FFCC00] group-hover:text-[#FFCC00] transition-colors">
                  0{i + 1}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
